import { Navigation, Pagination, Scrollbar, A11y, Autoplay, Keyboard } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import data from '../data.json';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useEffect, useState } from 'react';

const Swipercomponent = () => {
  const [swiperData, setSwiperData] = useState([]);

  useEffect(() => {
    setSwiperData(data.swiperArr);
  }, []);

  return (
    <Swiper
      style={{ marginTop: '90px' }}
      modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay, Keyboard]}
      spaceBetween={50}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
      autoplay={{ delay: 2000, disableOnInteraction: false }}
      keyboard={{ enabled: true }}
      onSwiper={(swiper) => console.log(swiper)}
      onSlideChange={() => console.log('slide change')}
    >
      {swiperData.map((ele, idx) => (
        <SwiperSlide key={idx}>
          <img src={ele.image} style={{ width: '100%', height: '100%' }} alt={ele.alt} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Swipercomponent;
